export default "__VITE_ASSET__Bxtppgeb__"